import React from "react";
import Participa from "../../components/Participa/Participa";
import { useEvents } from "../../hooks/useEvents";
import { useCalendar } from "../../hooks/useCalendar";
import CalendarPopup from "../../components/CalendarPopup/CalendarPopup";
import "./Agenda.css";

// Imatge de fallback per si no hi ha imatge disponible
import fallbackImage from "../../assets/images/socis/imatge1.jpg";

function Agenda() {
  // Obtenim les dades reals des de l'API
  const { esdeveniments, loadingEsdeveniments } = useEvents();

  // Usamos nuestro hook personalizado para la funcionalidad del calendario
  const {
    openCalendarMenu,
    handleCalendarClick,
    closeCalendarMenu,
    addToAppleOutlookCalendar,
    getGoogleCalendarURL,
  } = useCalendar();

  // Funció per formatar la data
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();

    // Array de noms de mesos en català (format abreviat)
    const monthNames = [
      "gen",
      "feb",
      "març",
      "abr",
      "maig",
      "juny",
      "jul",
      "ago",
      "set",
      "oct",
      "nov",
      "des",
    ];

    const month = monthNames[date.getMonth()];

    return { day, month };
  };

  // Mostra un indicador de càrrega mentre es carreguen les dades
  if (loadingEsdeveniments) {
    return (
      <section className="agenda">
        <div className="agenda__section">
          <div className="agenda__section-text">
            <h1>Agenda</h1>
            <p>Carregant esdeveniments...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="agenda">
        <div className="agenda__section">
          <div className="agenda__section-text">
            <h1>Agenda</h1>
            <p>
              Descobreix tots els esdeveniments que organitzem a La Flama. Des
              de concerts i tallers fins a xerrades i activitats culturals. No
              et perdis cap de les nostres propostes!
            </p>
          </div>
        </div>
        <div className="agenda__cards">
          {esdeveniments && esdeveniments.length > 0 ? (
            esdeveniments.map((event, index) => {
              const { day, month } = formatDate(event.data);
              return (
                <div key={index} className="home-agenda__carousel-card">
                  <div className="home-agenda__carousel-card-date">
                    <span className="date">{day}</span>
                    <span className="month">{month}</span>
                  </div>
                  <div className="home-agenda__carousel-card-image">
                    <img
                      src={event.imatge?.url || fallbackImage}
                      alt={event.titol}
                    />
                  </div>
                  <div className="home-agenda__carousel-card-content">
                    <div>
                      <h3 className="home-agenda__carousel-card-title">
                        {event.titol}
                      </h3>
                      <p className="home-agenda__carousel-card-description">
                        {event.descripcio}
                      </p>
                    </div>
                    <div style={{ position: "relative" }}>
                      <a
                        href="#Calendari"
                        className="afegir-al-calendari"
                        onClick={(e) => handleCalendarClick(event, index, e)}
                      >
                        AFEGIR AL MEU CALENDARI
                      </a>

                      {/* Componente de menú de calendario */}
                      {openCalendarMenu === index && (
                        <CalendarPopup
                          event={event}
                          onAddToAppleOutlook={addToAppleOutlookCalendar}
                          getGoogleCalendarURL={getGoogleCalendarURL}
                          onClose={closeCalendarMenu}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-events-message">
              No hi ha esdeveniments programats actualment. Torna aviat per
              veure les novetats!
            </div>
          )}
        </div>
      </section>
      <Participa />
    </>
  );
}

export default Agenda;
